export function authHeader() {
  let user = JSON.parse(localStorage.getItem("token"));
  if (user && user) {
    return { Authorization: "Bearer " + user };
  } else {
    return {};
  }
}
